import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/styles';

import Details from '../../details/Details';
import DirectDebitList from './DirectDebitList';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
  };
});

const Expand = ({ details, directDebitList, ...props }) => {
  const classes = useStyles();
  const translate = useTranslate();

  return (
    <div className={classes.root}>
      {cloneElement(details, {
        ...props,
        title: translate('resources.account.card_title.details'),
      })}
      {cloneElement(directDebitList, {
        ...props,
        title: translate('resources.account.card_title.gocardless_payment'),
      })}
    </div>
  );
};

Expand.propTypes = {
  details: PropTypes.element,
  directDebitList: PropTypes.element,
};

Expand.defaultProps = {
  details: <Details />,
  directDebitList: <DirectDebitList />,
};

export default Expand;
